// src/apis/announcements.js
import axiosInstance from './axiosInstance';
import BASE_URL from '../config/apiConfig';

// List paginated announcements
export async function getAnnouncements({ page = 1, per_page = 50 } = {}) {
  const { data } = await axiosInstance.get(`${BASE_URL}/announcements`, {
    params: { page, per_page },
  });
  return data; // { announcements, total, page, per_page, total_pages }
}

// Single announcement (for full description on click)
export async function getAnnouncementById(announcement_id) {
  const { data } = await axiosInstance.get(
    `${BASE_URL}/announcements/${encodeURIComponent(announcement_id)}`
  );
  return data; // single announcement object
}